<template>
  <el-container class="main-container">
    <div class="content-wrapper">
      <!-- 顶部图片 -->
      <section>
        <div class="top-banner-container">
          <img src="/static/ad6.jpg" class="top-banner">
        </div>
      </section>

      <section class="content-section">
        <!-- 公司信息部分 -->
        <el-row :gutter="20" type="flex" justify="center" class="company-row">
          <el-col :span="7" class="company-text">
            <div v-html="companyInfo[0].content"></div>
          </el-col>
          <el-col :span="7" class="company-image">
            <img :src="companyInfo[0].picUrl" class="company-pic">
          </el-col>
        </el-row>

        <!-- 招聘信息部分 -->
        <el-row v-for="(item,index) in hireList" :gutter="21" type="flex" justify="center" class="hire-row">
          <el-col :span="15" class="hire-card-col">
            <el-card shadow="never" class="hire-card">
              <div class="card-header">
                <span class="position-title">{{ item.position }}</span>
                <el-button type="text" @click="toggleContent(index)">
                  {{ item.collapsed ? t('expand') : t('collapse') }}
                  <i :class="item.collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                </el-button>
              </div>

              <div v-show="!item.collapsed" class="card-content">
                <div class="content-block">
                  <strong>{{ t('duties') }}</strong>
                  <div class="content-detail" v-html="item.jobResponsibilities"/>
                </div>

                <div class="content-block">
                  <strong>{{ t('requirements') }}</strong>
                  <div class="content-detail" v-html="item.requireInfo"/>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </section>
    </div>
  </el-container>
</template>

<script>
import {listCompanyInfo, listContactInfo,listHire} from "@/utils/http";

export default {
  name: "join",
  props: ['t', 'currentLang'],
  data() {
    return {
      currentLang: 'zh',
      flagCn: 'https://flagcdn.com/w40/cn.png',
      flagEn: 'https://flagcdn.com/w40/gb.png',
      params:{
        eType:0,
        type:0
      },
      companyInfo:[],
      hireList:[]
    };
  },
  created() {
    this.initCompanyInfo();
    this.initHire();
  },
  watch: {
    currentLang(newVal, oldVal) {
      this.onLangChange(newVal);
    }
  },
  methods: {
    onLangChange(lang) {
      if(lang==='zh'){
        this.params.eType=0;
      }else{
        this.params.eType=1;
      }
      this.initCompanyInfo();
      this.initHire();
    },
    initCompanyInfo(){
      listCompanyInfo(this.params).then(response => {
        this.companyInfo=response.rows;
      })
    },
    initHire(){
      listHire(this.params).then(response => {
        // 初始化每个招聘信息的折叠状态
        this.hireList = response.rows.map(item => ({
          ...item,
          collapsed: false
        }));
      })
    },
    toggleContent(index) {
      this.hireList[index].collapsed = !this.hireList[index].collapsed;
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
section, div, img {
  margin: 0;
  padding: 0;
}

img {
  display: block;
  max-width: 100%;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: none !important;
}

.main-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.content-wrapper {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.top-banner-container {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
}

.top-banner {
  width: 100%;
  height: auto;
}

.content-section {
  background-color: white;
  margin: 0 auto;
  padding: 0;
  color: #000;
  width: 100%;
  max-width: 1920px;
}

.company-row {
  padding-top: 40px;
  padding-bottom: 40px;
  max-width: 1600px;
  margin: 0 auto;
}

.company-text {
  margin: 0;
  padding: 0;
}

.company-pic {
  width: 586px;
  height: 346px;
  max-width: 100%;
}

.hire-row {
  padding-bottom: 40px;
  max-width: 1600px;
  margin: 0 auto;
}

.hire-card-col {
  margin: 0;
  padding: 0;
}

.hire-card {
  margin: 20px auto;
  max-width: 1200px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.position-title {
  font-size: 16px;
  font-weight: bold;
}

.card-content {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}

.content-block {
  margin-bottom: 10px;
}

.content-detail {
  margin: 5px 0 0 15px;
}

/* 高分辨率适配 */
@media screen and (min-width: 1921px) {
  .top-banner {
    width: 1920px;
    margin: 0 auto;
    display: block;
  }
}

/* 纯移动端样式 - 只在小于768px时生效 */
@media screen and (max-width: 768px) {
  .company-row {
    flex-direction: column;
    align-items: center;
    padding: 20px 15px;
    max-width: 100%;
  }

  .company-text, .company-image {
    width: 100% !important;
    max-width: 100%;
  }

  .company-text {
    margin-bottom: 30px;
  }

  .company-pic {
    width: 100%;
    height: auto;
    max-width: 100%;
  }

  .hire-row {
    max-width: 100%;
    padding: 0 15px 20px;
  }

  .hire-card-col {
    width: 100% !important;
    padding: 0;
  }

  .hire-card {
    margin: 10px auto;
    max-width: 100%;
  }

  .position-title {
    font-size: 14px;
  }

  .card-content {
    font-size: 13px;
  }
}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .company-row {
    padding: 15px 10px;
  }

  .hire-row {
    padding-bottom: 20px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .position-title {
    margin-bottom: 10px;
  }
  .top-banner{
    width:100%;
    height:auto;
    margin-top:35px;
    margin-bottom:35px;
    transform: translate(-1%, -4%) scale(4.0); /* 居中并放大 */
  }
  .top-banner-container{
    height:120rpx;
  }
}
</style>
